<footer class="footer--loader">
  <ngx-skeleton-loader
    [theme]="{
      width: '100%',
      height: '100%',
      'margin-bottom': '0',
      'background-color': '#f9f9fa',
    }"
  ></ngx-skeleton-loader>
  <div class="wrapper wrapper--loader container">
    <div class="first-row">
      <div class="contact">
        <ng-container *ngFor="let card of [].constructor(3); let i = index">
          <ng-container *ngIf="i === 0">
            <div class="contact__bubble-loader">
              <ngx-skeleton-loader
                [theme]="{
                  width: '100%',
                  height: '100%',
                  'margin-bottom': '0',
                }"
              ></ngx-skeleton-loader>
            </div>
          </ng-container>
          <div class="contact__card-loader">
            <ngx-skeleton-loader
              [theme]="{
                width: '100%',
                height: '100%',
                'margin-bottom': '0',
              }"
            ></ngx-skeleton-loader>
          </div>
        </ng-container>
      </div>
      <div class="links">
        <div class="links__h6-loader">
          <ngx-skeleton-loader
            [theme]="{
              width: '100%',
              height: '100%',
              'margin-bottom': '0',
            }"
          ></ngx-skeleton-loader>
        </div>
        <ng-container *ngFor="let link of [].constructor(5)">
          <div class="links__link-loader">
            <ngx-skeleton-loader
              [theme]="{
                width: '100%',
                height: '100%',
                'margin-bottom': '0',
              }"
            ></ngx-skeleton-loader>
          </div>
        </ng-container>
      </div>
      <div class="support">
        <div class="support__h6-loader">
          <ngx-skeleton-loader
            [theme]="{
              width: '100%',
              height: '100%',
              'margin-bottom': '0',
            }"
          ></ngx-skeleton-loader>
        </div>
        <div class="support__subtitle-loader">
          <ngx-skeleton-loader
            [theme]="{
              width: '100%',
              height: '100%',
              'margin-bottom': '0',
            }"
          ></ngx-skeleton-loader>
        </div>
        <div class="support__strong-text-loader">
          <ngx-skeleton-loader
            [theme]="{
              width: '100%',
              height: '100%',
              'margin-bottom': '0',
            }"
          ></ngx-skeleton-loader>
        </div>
        <div class="support__button-loader">
          <ngx-skeleton-loader
            [theme]="{
              width: '100%',
              height: '100%',
              'margin-bottom': '0',
            }"
          ></ngx-skeleton-loader>
        </div>
      </div>
      <div class="newsletter">
        <div class="newsletter__h6-loader">
          <ngx-skeleton-loader
            [theme]="{
              width: '100%',
              height: '100%',
              'margin-bottom': '0',
            }"
          ></ngx-skeleton-loader>
        </div>
        <div class="newsletter__subtitle-loader">
          <ngx-skeleton-loader
            [theme]="{
              width: '100%',
              height: '100%',
              'margin-bottom': '0',
            }"
          ></ngx-skeleton-loader>
        </div>
        <div class="newsletter__strong-text-loader">
          <ngx-skeleton-loader
            [theme]="{
              width: '100%',
              height: '100%',
              'margin-bottom': '0',
            }"
          ></ngx-skeleton-loader>
        </div>
        <div class="newsletter__button-loader">
          <ngx-skeleton-loader
            [theme]="{
              width: '100%',
              height: '100%',
              'margin-bottom': '0',
            }"
          ></ngx-skeleton-loader>
        </div>
      </div>
    </div>
    <div class="second-row">
      <div class="social-media">
        <ng-container *ngFor="let link of [].constructor(5)">
          <div class="social-media__icon-loader">
            <ngx-skeleton-loader
              [theme]="{
                width: '100%',
                height: '100%',
                'margin-bottom': '0',
              }"
            ></ngx-skeleton-loader>
          </div>
        </ng-container>
      </div>
      <div class="copy-right">
        <ng-container *ngFor="let link of [].constructor(2)">
          <div class="copy-right__link-loader">
            <ngx-skeleton-loader
              [theme]="{
                width: '100%',
                height: '100%',
                'margin-bottom': '0',
              }"
            ></ngx-skeleton-loader>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</footer>
